export default __webpack_public_path__ + "static/media/16.3feb406e.jpg";